import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

import { Rate, Select } from 'antd';
import { capitalizeFirstLetter, checkUndefine } from '../../../../../../helpers/functions';
import DEFINE, { HOTEL, UPLOAD_DIRECTORY, DETAIL_ACTIONS } from '../../../../../../constants/Define';
import {
    FormWrapperItem,
    FormWrapperInputComponent,
} from "../../../../common/component/Index";
import Input from "../../../../common/component/Input";
import TextArea from "../../../../common/component/TextArea";
import Wrapper from "../../../../common/component/Wrapper";
import UploadImage from "../../../../common/component/UploadImage";
import RichTextEditor, { ClassicEditor } from '../../../../common/component/RichTextEditor';
import { cloneDeep, get } from "lodash";

import './styles.less';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';

class BasicInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            amenities: [],
            dataAmenity: [],
        };
        this.descriptionInputRef = React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.amenities !== state.amenities) {
            const newAmenities = props.amenities.filter(item => item.isActive)
            const newHotelAmenity = props.hotel.amenity.filter(item => newAmenities.find(i => i.id === item))
            return {
                amenities: newAmenities,
                dataAmenity: newHotelAmenity
            };
        }
        return null;
    }

    onChangeImagesOrder = (e) => {
        const media = cloneDeep(this.props.hotel?.media || []);
        const newMedia = media.map(x=>{
            return {
                ...x,
                order: e.findIndex(y=>y.endsWith(x.url))
            };
        }).sort((a, b) => a.order - b.order);
        this.props.onChange('media', newMedia);
    }

    render() {
        const { t, hotel, uploading, disabled, validation, action } = this.props;
        const { amenities, dataAmenity } = this.state;
        
        return (
            <Wrapper className="basic-info-section">
                <h3 className={`ml-3`}>{t('item.hotel.basicInfo')}</h3>
                <FormWrapperItem>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.images`)}
                        >
                            <UploadImage
                                multiple={true}
                                loading={uploading}
                                thumbnailSize={120}
                                buttonSize={120}
                                disabledUpload={disabled}
                                disabledRemove={disabled}
                                uploadText={t('item.hotel.uploadFile')}
                                loadingText={t('item.hotel.uploading')}
                                onChange={this.props.onUploadImage}
                                onRemoveThumbnail={this.props.onRemoveImage}
                                thumbnails={this.getThumbSources(hotel.media)}
                                allowChangeOrder={true}
                                onChangeOrder={this.onChangeImagesOrder}/>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={hotel.name}
                            validation={validation.name}
                            labelTitle={t(`item.hotel.name`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`name`} onChange={(e) => this.props.onChange('name', e.target.value)}
                                value={checkUndefine(hotel.name)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={hotel.code}
                            validation={validation.code}
                            labelTitle={t(`item.hotel.code`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`code`} onChange={(e) => this.props.onChange('code', e.target.value)}
                                value={checkUndefine(hotel.code)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={hotel.star}
                            validation={validation.star}
                            labelTitle={t(`item.hotel.star`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Wrapper>
                                <Rate value={hotel.star} onChange={(value) => this.props.onChange('star', value)} />
                            </Wrapper>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.tripAdvisorLocationId`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`tripAdvisorLocationId`} onChange={(e) => this.props.onChange('tripAdvisorLocationId', e.target.value)}
                                value={checkUndefine(hotel.tripAdvisorLocationId)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            isValidation={true}
                            dataValidation={this.props.napasReconEmail}
                            validation={validation.napasReconEmail}
                            labelTitle={t(`item.hotel.napasReconEmail`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="email1@example.com,email2@example.com" type={`text`}
                                className={`form-control`}
                                name={`napasReconEmail`}
                                onChange={(e) => this.props.onChangeNapasReconEmail(e.target.value)}
                                value={checkUndefine(this.props.napasReconEmail)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    {
                        hotel.isBeachVilla && 
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                labelTitle={t(`item.hotel.hardblock`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input placeholder="" type={`number`}
                                    className={`form-control`}
                                    name={`hardblock`} onChange={(e) => this.props.onChange('hardblock', e.target.value)}
                                    value={hotel.hardblock}
                                />
                            </FormWrapperInputComponent>
                        </Wrapper>
                    }
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.types`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Select className="select-types"
                                showArrow
                                mode="multiple"
                                placeholder={t(`item.hotel.selectTypes`)}
                                value={hotel.types}
                                onChange={types => this.props.onChange('types', types)}
                                style={{ width: '100%' }}
                            >
                                {Object.keys(HOTEL.TYPE).map(type => (
                                    <Select.Option key={HOTEL.TYPE[type]} value={HOTEL.TYPE[type]}>
                                        {t(`item.hotel.${HOTEL.TYPE[type]}`)}
                                    </Select.Option>
                                ))}
                            </Select>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.hotline`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control text-right`}
                                name={`hotline`} onChange={this.onPhoneChange}
                                value={hotel.hotline} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.review`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control text-right`}
                                name={`review`} onChange={(e) => this.props.onChange('review', e.target.value)}
                                value={hotel.review} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.thumbnailTag`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`thumbnailTag`} onChange={(e) => this.props.onChange('thumbnailTag', e.target.value)}
                                value={hotel.thumbnailTag} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.urlSlug`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`urlSlug`} onChange={(e) => this.props.onChange('urlSlug', e.target.value)}
                                value={hotel.urlSlug} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.shortDescription`)}
                        >
                            <TextArea
                                className="form-control" name="shortDescription"
                                onChange={e => this.props.onChange('shortDescription', e.target.value.trimLeft())}
                                value={hotel.shortDescription} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.description`)}
                        >
                            <RichTextEditor
                                ref={this.descriptionInputRef}
                                disabled={disabled}
                                editor={ClassicEditor}
                                data={hotel.description}
                                config={{ uploadDirectory: UPLOAD_DIRECTORY.HOTEL }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    return this.props.onChange("description", data)
                                }}
                            />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle="Điều khoản mặc định"
                        >
                            <TextArea
                                rows={3}
                                className="form-control"
                                name="defaultRateDescription"
                                onChange={e => this.props.onChange('defaultRateDescription', e.target.value)}
                                value={hotel.defaultRateDescription} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.amenity`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <AntSelect className="select-types"
                                showArrow
                                mode="multiple"
                                optionFilterProp="children"
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.hotel.amenity")).toLowerCase())}
                                value={dataAmenity}
                                onChange={amenity => this.props.onChange('amenity', amenity)}
                                style={{ width: '100%' }}
                            >
                                {(amenities || []).map(amenity => (
                                    <AntOption key={amenity.id} value={amenity.id}>
                                        {amenity.name}
                                    </AntOption>
                                ))}
                            </AntSelect>
                        </FormWrapperInputComponent>
                    </Wrapper>
                </FormWrapperItem>
            </Wrapper>
        );
    }

    getThumbSources(thumbs) {
        return thumbs.filter(t => t && Object.keys(t).length > 0).map(t => t.url && t.url.startsWith('http') ? t.url : `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.url}`)
    }

    onPhoneChange = (event) => {
        const phoneStr = event.target.value;
        const regex = /[0-9 .\-\(\)]+$/;
        if (!phoneStr || regex.test(phoneStr))
            this.props.onChange('hotline', phoneStr)
    }

    setDescription = (description) => {
        if (this.descriptionInputRef.current && get(this.descriptionInputRef.current, 'editor.setData') && description) {
            return this.descriptionInputRef.current.editor.setData(description)
        }
    }

}

BasicInfo.defaultProps = {
    onChange: () => { },
    onChangeNapasReconEmail: () => { },
    action: DETAIL_ACTIONS.CREATE,
}

export default withTranslation(undefined, { withRef: true })(BasicInfo);
